var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.47 4.986A1.5 1.5 0 0 0 41.31 5H27.5a1.5 1.5 0 1 0 0 3h10.379l-15.44 15.44a1.5 1.5 0 1 0 2.122 2.12L40 10.122V20.5a1.5 1.5 0 1 0 3 0V6.69a1.5 1.5 0 0 0-1.53-1.704zM12.5 8C8.375 8 5 11.375 5 15.5v20c0 4.125 3.375 7.5 7.5 7.5h20c4.125 0 7.5-3.375 7.5-7.5v-10a1.5 1.5 0 1 0-3 0v10c0 2.503-1.997 4.5-4.5 4.5h-20A4.477 4.477 0 0 1 8 35.5v-20c0-2.503 1.997-4.5 4.5-4.5h10a1.5 1.5 0 1 0 0-3h-10z"
  })));
};
export default SvgExternalLink;